// extracted by mini-css-extract-plugin
module.exports = {"container":"EmployeeInfoWaiveModal_container__UbNDj","text":"EmployeeInfoWaiveModal_text__36VGm"};